import { createContext } from 'react'
import { DropdownContextType } from './types'

export const DropdownContext = createContext<DropdownContextType>({
  isOpen: false,
  isDarkMode: false
})
